import { useQuery } from '@tanstack/react-query';

import { clientService } from '@/services/client-service';
import type { UUID } from '@/utils/uuid';

import { clientQueryKeys } from './query-keys';

/**
 * Hook to fetch a single client by ID.
 * Enabled only when both tenantId and clientId are provided.
 */
export function useFindClient(tenantId?: UUID, clientId?: UUID) {
  return useQuery({
    queryKey: clientQueryKeys.detail(tenantId, clientId),
    queryFn: () => clientService.findClient(tenantId!, clientId!),
    enabled: !!tenantId && !!clientId,
  });
}
